import { useState } from 'react';
import { faqs, faqCategories } from '@/mocks/home';

export default function FaqSection() {
  const [category, setCategory] = useState('all');
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  const visible = category === 'all' ? faqs : faqs.filter((f) => f.category === category);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-700">
            FAQ
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-700">
            把大家最常问的问题按类别整理，点击任意一条即可展开查看回答。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {faqCategories.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => setCategory(c.id)}
              className={`whitespace-nowrap rounded-full border px-4 py-2 text-xs md:text-sm font-medium transition-colors cursor-pointer ${
                category === c.id
                  ? 'border-primary-300 bg-primary-100 text-primary-700'
                  : 'border-background-200 bg-background-100 text-foreground-700 hover:border-secondary-300'
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {visible.map((f) => {
            const open = openId === f.id;
            return (
              <div
                key={f.id}
                className={`overflow-hidden rounded-lg border bg-background-100/60 transition-colors ${
                  open ? 'border-primary-300' : 'border-background-200'
                }`}
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenId(open ? null : f.id)}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                      {f.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-primary-700 transition-transform duration-300 ${
                        open ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </button>
                </h3>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-4 pb-4 md:px-6 md:pb-6 text-sm md:text-base leading-relaxed text-foreground-700">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}